import React from 'react';
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

interface FishStat {
  fishId: string;
  fishName: string;
  totalCatches: number;
  taken: number;
  released: number;
  avgLength: number | null;
  avgWeight: number | null;
}

export const FishStatsChart = ({data}: { data: FishStat[] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="card h-100">
        <div className="card-header">
          <h3 className="card-title">Top 10 Fischarten</h3>
        </div>
        <div className="card-body">
          <div className="text-muted">Keine Daten verfügbar</div>
        </div>
      </div>
    );
  }

  const top10 = data.slice(0, 10);

  return (
    <div className="card h-100">
      <div className="card-header">
        <h3 className="card-title">Top 10 Fischarten</h3>
      </div>
      <div className="card-body">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={top10}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="fishName" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="totalCatches" fill="#3b82f6" name="Anzahl Fänge" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
